import { IconButton, IconButtonProps, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

interface CategoryButtonProps extends IconButtonProps {
    active?: boolean;
}

export const CategoryButton = styled(IconButton, { shouldForwardProp: (prop: string) => prop !== 'active' })<CategoryButtonProps>(({ theme, active }: { theme: Theme, active?: boolean }) => ({
    borderRadius: 5,
    padding: 2,
    margin: "0 6px",
    backgroundColor: active === true ? theme.palette.text.primary : "transparent",
}));